export default "__VITE_ASSET__CzBOrxOv__"